// extracted by mini-css-extract-plugin
export default {"icon":"IconStatic_icon__-3Di8"};